import PropTypes from 'prop-types';
import { useRef } from 'react';
import './otpInput.scss';

const AppOtpInput = ({ value = [], onChange, length = 6, error = false }) => {
   const inputs = useRef([]);

   const handleChange = (index, val) => {
      if (!/^\d*$/.test(val)) return;

      const newValue = [...value];
      const digit = val.length > 1 ? val.charAt(val.length - 1) : val;
      newValue[index] = digit;
      onChange(newValue);

      if (digit !== '' && index < length - 1) {
         inputs.current[index + 1]?.focus();
      }
   };

   const handleKeyDown = (index, e) => {
      if (e.key === 'Backspace') {
         if (!value[index] && index > 0) {
            inputs.current[index - 1]?.focus();
            const newValue = [...value];
            newValue[index - 1] = '';
            onChange(newValue);
         }
      } else if (e.key === 'ArrowRight' && index < length - 1) {
         inputs.current[index + 1]?.focus();
      } else if (e.key === 'ArrowLeft' && index > 0) {
         inputs.current[index - 1]?.focus();
      }
   };

   const handlePaste = e => {
      e.preventDefault();
      const pastedData = e.clipboardData.getData('text/plain').trim();
      if (!/^\d+$/.test(pastedData)) return;

      const digits = pastedData.split('').slice(0, length);
      const newValue = Array(length).fill('');

      digits.forEach((digit, i) => {
         newValue[i] = digit;
      });

      onChange(newValue);

      const nextIndex = Math.min(digits.length, length - 1);
      inputs.current[nextIndex]?.focus();
   };

   return (
      <div className="ct-otp-group ct-flex ct-jcBetween ct-gap8">
         {Array.from({ length }).map((_, index) => (
            <input
               key={`otp-input-${index * 2 + 1}`}
               ref={el => (inputs.current[index] = el)}
               type="text"
               maxLength="1"
               className={`ct-input ct-otp-input ${value[index] ? 'ct-filled' : ''} ${error ? 'ct-input-error' : ''}`}
               value={value[index] || ''}
               onChange={e => handleChange(index, e.target.value)}
               onKeyDown={e => handleKeyDown(index, e)}
               onPaste={handlePaste}
               onFocus={e => {
                  const target = e.target;
                  setTimeout(() => {
                     target.setSelectionRange(target.value.length, target.value.length);
                  }, 0);
               }}
               autoFocus={index === 0}
               autoComplete="off"
               inputMode="numeric"
            />
         ))}
      </div>
   );
};

AppOtpInput.propTypes = {
   value: PropTypes.arrayOf(PropTypes.string),
   onChange: PropTypes.func.isRequired,
   length: PropTypes.number,
   error: PropTypes.bool,
};

export default AppOtpInput;
